<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: "WeekDayDurations",

    props: {
        durations: {
            type: Array,
            required: true
        },
        accountingFirmUserId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            form: {
                monday: 0,
            }
        }
    },

    computed: {
        totalDuration() {
            return parseFloat(this.form.monday) +
                parseFloat(this.form.tuesday) +
                parseFloat(this.form.wednesday) +
                parseFloat(this.form.thursday) +
                parseFloat(this.form.friday) +
                parseFloat(this.form.saturday)
        }
    },

    created() {
        this.form = this.durations
    },

    methods: {
        async updateDurations() {
            try {
                await this.$axios.put('accountingFirmUsers/' + this.accountingFirmUserId + '/updateWeekDurations', this.form)
            } catch (e) {
                //
            }
        }
    }
}
</script>

<template>
    <div>
        <h4>Durée de travail par jour</h4>
        <b-row>
            <b-col sm="2">
                <b-form-group label="Lundi">
                    <b-input v-model="form.monday" type="number" step="0.5" class="text-right"
                             @input="updateDurations"/>
                </b-form-group>
            </b-col>
            <b-col sm="2">
                <b-form-group label="Mardi">
                    <b-input v-model="form.tuesday" type="number" step="0.5" class="text-right"
                             @input="updateDurations"/>
                </b-form-group>
            </b-col>
            <b-col sm="2">
                <b-form-group label="Mercredi">
                    <b-input v-model="form.wednesday" type="number" step="0.5" class="text-right"
                             @input="updateDurations"/>
                </b-form-group>
            </b-col>
            <b-col sm="2">
                <b-form-group label="Jeudi">
                    <b-input v-model="form.thursday" type="number" step="0.5" class="text-right"
                             @input="updateDurations"/>
                </b-form-group>
            </b-col>
            <b-col sm="2">
                <b-form-group label="Vendredi">
                    <b-input v-model="form.friday" type="number" step="0.5" class="text-right"
                             @input="updateDurations"/>
                </b-form-group>
            </b-col>
            <b-col sm="2">
                <b-form-group label="Samedi">
                    <b-input v-model="form.saturday" type="number" step="0.5" class="text-right"
                             @input="updateDurations"/>
                </b-form-group>
            </b-col>
        </b-row>
        <p>TOTAL Semaine : {{ totalDuration }} heures</p>
    </div>
</template>

<style scoped>

</style>
